<!--
Copyright 2020 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <a v-if="disabledTitle == null" class="enketo-fill btn btn-primary"
    :href="href" target="_blank">
    <slot></slot>
  </a>
  <button v-else type="button" class="enketo-fill btn btn-primary" disabled
    :title="disabledTitle">
    <slot></slot>
  </button>
</template>

<script>
import Form from '../../presenters/form';
import { enketoBasePath } from '../../util/util';

export default {
  name: 'EnketoFill',
  props: {
    formVersion: {
      type: Form,
      required: true
    }
  },
  computed: {
    disabledTitle() {
      if (this.formVersion.publishedAt != null &&
        this.formVersion.state !== 'open')
        return this.$t('disabled.notOpen');
      if (this.formVersion.enketoId == null)
        return this.$t('disabled.processing');
      return null;
    },
    href() {
      const encodedId = encodeURIComponent(this.formVersion.enketoId);
      return `${enketoBasePath}/${encodedId}`;
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    "disabled": {
      "processing": "Web Form is not available yet. It has not finished being processed. Please refresh later and try again.",
      "notOpen": "This Form is not accepting new Submissions right now."
    }
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "disabled": {
      "processing": "Webový formulář zatím není k dispozici. Zpracování se nedokončilo. Aktualizujte prosím později a zkuste to znovu.",
      "notOpen": "Tento formulář nyní nepřijímá nové podané příspěvky."
    }
  },
  "de": {
    "disabled": {
      "processing": "Das Webformular ist noch nicht erstellt, es wird gerade erstellt. Bitte aktualisieren Sie später und versuchen Sie es noch einmal.",
      "notOpen": "Zurzeit können für dieses Formulare keine Übermittlungen angenommen werden."
    }
  },
  "es": {
    "disabled": {
      "processing": "El formulario web aún no está disponible. No ha terminado de ser procesado. Por favor actualice más tarde e intente nuevamente.",
      "notOpen": "Este formulario no acepta nuevos envíos en este momento."
    }
  },
  "fr": {
    "disabled": {
      "processing": "Le Formulaire Web n'est pas encore disponible. Il n'a pas encore été traité. Veuillez rafraîchir plus tard et réessayer.",
      "notOpen": "Ce Formulaire n'accepte pas de nouvelles soumissions pour le moment."
    }
  }
}
</i18n>
